module.exports = __webpack_public_path__ + "img/Führungsstelle.00bb9c72.svg";